import Button from "@material-ui/core/Button";
import React from "react";

class Shareidea extends React.Component {
  render() {
    return (
      <div
        className="text-center rounded-rectangle-paper padding16 width100"
        style={{ boxSizing: "border-box", borderRadius: 4 }}
        >
        <p className="small-dark-secondary">
          Have any ideas for improving your dashboard?
        </p>
        <Button
          variant="contained"
          className="btn btn-primary-sm-blue margin-top-16"
          onClick={this.props.openForm}
        >
          Share idea
        </Button>
      </div>
    );
  }
}

export default Shareidea;
